import React, { useState, useEffect } from 'react';
import {
  Table,
  Header,
  Pagination,
  Button,
  TextFilter,
  CollectionPreferences,
} from '@amzn/awsui-components-react-v3';
import { useCollection } from '@amzn/awsui-collection-hooks';
import { InfoLink } from '../info';
import { PAGE_SIZE_OPTIONS, getVisibleContentOptions, mergeFaAndLaRows, EmptyState } from '../elements';
import '../../../styles/spotcp.css';

export const ReportTable = (props) => {
  const { columnDefinitions, laData, faData, title, description, updateTools, infoComponent } = props;
  const VISIBLE_CONTENT_OPTIONS = getVisibleContentOptions(columnDefinitions);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState(null);

  const [preferences, setPreferences] = useState({
    pageSize: 35,
    visibleContent: VISIBLE_CONTENT_OPTIONS[0].options.map((opt) => opt.id).filter((id) => !id.endsWith('_la')),
    wrapLines: true,
  });

  useEffect(() => {
    let merged = mergeFaAndLaRows(faData, laData);
    setTableData(merged);
  }, [laData, faData]);

  useEffect(() => {
    setLoading(tableData ? false : true);
  }, [tableData]);

  const { items, actions, collectionProps, filterProps, paginationProps } = useCollection(tableData || [], {
    filtering: {
      noMatch: (
        <EmptyState
          title="No matches"
          subtitle="We can’t find a match."
          action={<Button onClick={() => actions.setFiltering('')}>Clear filter</Button>}
        />
      ),
    },
    pagination: { pageSize: preferences.pageSize },
    sorting: {}, // use default so pass empty object
  });

  return (
    <Table
      className="spotcp-table"
      {...collectionProps}
      columnDefinitions={columnDefinitions}
      visibleColumns={preferences.visibleContent}
      items={items}
      loading={loading}
      resizableColumns
      wrapLines={preferences.wrapLines}
      loadingText="Loading Data..."
      filter={<TextFilter {...filterProps} />}
      pagination={<Pagination {...paginationProps} />}
      preferences={
        <CollectionPreferences
          title="Preferences"
          confirmLabel="Confirm"
          cancelLabel="Cancel"
          preferences={preferences}
          onConfirm={({ detail }) => setPreferences(detail)}
          pageSizePreference={{
            title: 'Page size',
            options: PAGE_SIZE_OPTIONS,
          }}
          wrapLinesPreference={{
            label: 'Wrap lines',
            description: 'Check to see all the text and wrap the lines',
          }}
          visibleContentPreference={{
            title: 'Select visible columns',
            options: VISIBLE_CONTENT_OPTIONS,
          }}
        />
      }
      header={
        <Header variant="h2" description={description} info={<InfoLink onFollow={() => updateTools(infoComponent)} />}>
          {title}
        </Header>
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/spotcp/custom/report-table.jsx